import {LIGHT_TEXT_COLOR} from "../common/styles";

export const tdStyles = {
    borderBottom: "1px solid rgba(0,0,0,0.07)",
    padding: "5px 10px",
    verticalAlign: "top",
    textAlign: "left"
};
export const thStyles = Object.assign({}, tdStyles, {
    fontWeight: "normal",
    color: LIGHT_TEXT_COLOR
});



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/tableStyles.js
 **/